import { render, staticRenderFns } from "./courses-encitefoci.vue?vue&type=template&id=9ae9742c"
import script from "./courses-encitefoci.vue?vue&type=script&lang=js"
export * from "./courses-encitefoci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports